import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  position: {
    default: 'bottom',
    editor: 'dropdown',
    editorOptions: [
      'auto',
      'auto-start',
      'auto-end',
      'bottom',
      'bottom-start',
      'bottom-end',
      'top',
      'top-start',
      'top-end',
      'left',
      'left-start',
      'left-end',
      'right',
      'right-start',
      'right-end',
    ],
  },
  arrowAccent: {
    default: 'viridiangreen',
    editor: 'dropdown',
    editorOptions: Accents,
  },
  suppressArrow: {
    default: false,
    editor: 'checkbox',
  },
  suppressCloseIcon: {
    default: false,
    editor: 'checkbox',
  },
  alwaysOpenWhenClick: {
    default: false,
    editor: 'checkbox',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-popover where you can change all the attributes',
  coreComponent: {
    html: `<div>
  <div style='text-align: center; margin-top: 50px;'>
    <tag-button class='popover-source' icon='Chat' squared style='display: inline-block;'></tag-button>
  </div>
  <tag-popover popover-for=".popover-source"{{...knobs}}>
    <div style="padding: 15px 20px">
      <tag-text text='This is a popover'>
    </div>
  </tag-popover>
</div>`,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `
    <div style='text-align: center; margin-top: 50px;'>
      <tag3-button class='popover-source3' icon="Chat" squared style='display: inline-block;' {{colour-scheme}}></tag3-button>
    </div>
      <tag3-popover popover-for=".popover-source3" {{...knobs}}>
          <div style="padding: 15px 20px">
            <tag3-text>This is a popover</tag3-text>
          </div>
      </tag3-popover>
    `,
    knobs: {
      arrowAccent: {
        default: 'viridiangreen',
        editor: 'dropdown',
        editorOptions: Accents,
      },
      suppressCloseIcon: {
        default: false,
        editor: 'checkbox',
      },
      tippyProps: {
        default: '{"placement": "bottom", "arrow": true, "hideOnClick": true}',
        editor: 'textbox',
      },
      'colour-scheme': {
        editor: 'dropdown',
        editorOptions: ['light', 'dark', 'default', ''],
        default: '',
      },
      device: {
        editor: 'dropdown',
        editorOptions: ['mobile', 'desktop', ''],
        default: '',
      },
    },
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    return (
    <div>
      <div style={{textAlign: 'center', marginTop: '50px'}}>
        <TagButton className='popover-source' icon='Chat' squared style={{display: 'inline-block'}}/>
      </div>
      <TagPopover popoverFor=".popover-source"{{...knobs}}>
        <div style={{padding: '15px 20px'}}>
          <TagText text='This is a popover' />
        </div>
      </TagPopover>
    </div>
    )
    };`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    return (
    <div>
      <div style={{textAlign: 'center', marginTop: '50px'}}>
        <Tag3Button className='popover-source' icon='Chat' squared style={{display: 'inline-block'}} {{colour-scheme}}/>
      </div>
      <Tag3Popover popoverFor=".popover-source"{{...knobs}}>
        <div style={{padding: '15px 20px'}}>
            <Tag3Text text='This is a popover' />
        </div>
      </Tag3Popover>
    </div>
    )
    };`,
    knobs: {
      arrowAccent: {
        default: 'viridiangreen',
        editor: 'dropdown',
        editorOptions: Accents,
      },
      suppressCloseIcon: {
        default: false,
        editor: 'checkbox',
      },
      tippyProps: {
        default: '{placement: "bottom", arrow: true, hideOnClick: true}',
        editor: 'textbox',
        qualifierStart: '{',
        qualifierEnd: '}',
      },
      'colour-scheme': {
        editor: 'dropdown',
        editorOptions: ['light', 'dark', 'default', ''],
        default: '',
      },
      device: {
        editor: 'dropdown',
        editorOptions: ['mobile', 'desktop', ''],
        default: '',
      },
    },
  },
};

const RichContentStory: Story = {
  title: 'Rich content',
  description: 'A tag-popover with rich content',
  coreComponent: {
    html: `<div>
  <div style='text-align: center; margin-top: 50px;'>
    <tag-button class='popover-source' icon='Chat' squared style='display: inline-block;'></tag-button>
  </div>
  <tag-popover popover-for=".popover-source">
    <div style="padding: 15px 20px; width: 480px;">
        <tag-field value="Luke Skywalker" value-style='{"font-size": "24px", "margin-bottom": "15px"}'></tag-field>
        <div style="display: flex">
          <div>
              <tag-field label="Date of Birth" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="19BBY"></tag-field>
              <tag-field label="Height" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="172"></tag-field>
              <tag-field label="mass" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="77"></tag-field>
              <tag-field label="Gender" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="male"></tag-field>
          </div>
          <div style="margin-left:50px;">
              <tag-field label="Hair Colour" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="blonde"></tag-field>
              <tag-field label="Skin Colour" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="fair"></tag-field>
              <tag-field label="Eye Colour" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="blue"></tag-field>
          </div>
        </div>
    </div>
  </tag-popover>
</div>`,
  },
  coreComponent_v3: {
    html: `<div>
  <div style='text-align: center; margin-top: 50px;'>
    <tag3-button class='popover-source' icon='Chat' squared style='display: inline-block;'></tag3-button>
  </div>
  <tag3-popover popover-for=".popover-source">
    <div style="padding: 15px 20px; width: 480px;">
      <tag-field value="Luke Skywalker" value-style='{"font-size": "24px", "margin-bottom": "15px"}'></tag-field>
      <div style="display: flex">
        <div>
            <tag-field label="Date of Birth" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="19BBY"></tag-field>
            <tag-field label="Height" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="172"></tag-field>
            <tag-field label="mass" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="77"></tag-field>
            <tag-field label="Gender" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="male"></tag-field>
        </div>
        <div style="margin-left:50px;">
            <tag-field label="Hair Colour" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="blonde"></tag-field>
            <tag-field label="Skin Colour" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="fair"></tag-field>
            <tag-field label="Eye Colour" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="blue"></tag-field>
        </div>
      </div>
    </div>
  </tag3-popover>
</div>`,
  },
  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    return (
    <div>
      <div style={{textAlign: 'center', marginTop: '50px'}}>
        <TagButton className='popover-source' icon='Chat' squared style={{display: 'inline-block'}}/>
      </div>
      <TagPopover popoverFor=".popover-source">
        <div style={{padding: '15px 20px', width: '480px'}}>
          <TagField value="Luke Skywalker" valueStyle={{"font-size": "24px", "margin-bottom": "15px"}}/>
          <div style={{display: 'flex'}}>
            <div>
                <TagField label="Date of Birth" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="19BBY"/>
                <TagField label="Height" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="172"/>
                <TagField label="mass" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="77"/>
                <TagField label="Gender" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="male"/>
            </div>
            <div style={{marginLeft:'50px'}}>
                <TagField label="Hair Colour" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="blonde"/>
                <TagField label="Skin Colour" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="fair"/>
                <TagField label="Eye Colour" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="blue"/>
            </div>
          </div>
        </div>
      </TagPopover>
    </div>
    )
  };`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    return (
    <div>
      <div style={{textAlign: 'center', marginTop: '50px'}}>
        <Tag3Button className='popover-source' icon='Chat' squared style={{display: 'inline-block'}}/>
      </div>
      <Tag3Popover popoverFor=".popover-source">
        <div style={{padding: '15px 20px', width: '480px'}}>
          <TagField value="Luke Skywalker" valueStyle={{"font-size": "24px", "margin-bottom": "15px"}}/>
          <div style={{display: 'flex'}}>
            <div>
                <TagField label="Date of Birth" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="19BBY"/>
                <TagField label="Height" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="172"/>
                <TagField label="mass" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="77"/>
                <TagField label="Gender" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="male"/>
            </div>
            <div style={{marginLeft:'50px'}}>
                <TagField label="Hair Colour" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="blonde"/>
                <TagField label="Skin Colour" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="fair"/>
                <TagField label="Eye Colour" label-style={{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}} value="blue"/>
            </div>
          </div>
        </div>
      </Tag3Popover>
    </div>
    )
  };`,
  },
};

const ThreePopoversStory: Story = {
  title: 'Three popovers',
  description: 'Three popovers',
  coreComponent: {
    html: `<div>
  <tag-button class='popover-1-source' style='display: inline-block;'>Button 1</tag-button>
  <tag-popover popover-for='.popover-1-source' arrow-accent='border'>
    <div style='padding: 10px; width: 180px;'>Popover for button 1</div>
  </tag-popover>

  <tag-button class='popover-2-source' style='display: inline-block;'>Button 2</tag-button>
  <tag-popover popover-for='.popover-2-source' arrow-accent='border'>
    <div style='padding: 10px; width: 180px;'>Popover for button 2</div>
  </tag-popover>

  <tag-button class='popover-3-source' style='display: inline-block;'>Button 3 - Popover Suppress Close</tag-button>
  <tag-popover popover-for='.popover-3-source' arrow-accent='border' suppress-close-icon='true'>
    <div style='padding: 10px; width: 180px;'>Popover for button 3</div>
  </tag-popover>
</div>`,
  },
  coreComponent_v3: {
    html: `<div style="display: flex">
      <tag3-simple-button class='popover-1-source' style='margin-right: 5px;'>Button 1</tag3-simple-button>
      <tag3-popover popover-for='.popover-1-source' arrow-accent='border' tippy-props='{"placement": "bottom"}'>
          <div style='padding: 10px; width: 180px;'>Popover for button 1</div>
      </tag3-popover>

      <tag3-simple-button class='popover-2-source' style='margin-right: 5px;'>Button 2</tag3-simple-button>
      <tag3-popover popover-for='.popover-2-source' arrow-accent='border' tippy-props='{"placement": "bottom"}'>
          <div style='padding: 10px; width: 180px;'>Popover for button 2</div>
      </tag3-popover>

      <tag3-simple-button class='popover-3-source'>Button 3 - Popover Suppress Close</tag3-simple-button>
      <tag3-popover popover-for='.popover-3-source' arrow-accent='border' suppress-close-icon tippy-props='{"placement": "bottom"}'>
        <div style='padding: 10px; width: 180px;'>Popover for button 3</div>
      </tag3-popover>
    </div>`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    return (
    <div>
      <TagButton className='popover-1-source' text='Button1' style={{display: 'inline-block'}}/>
      <TagPopover popover-for='.popover-1-source' arrowAccent='border'>
        <div style={{padding: '10px', width: '180px'}}>Popover for button 1</div>
      </TagPopover>

      <TagButton className='popover-2-source' text='Button2' style={{display: 'inline-block'}}/>
      <TagPopover popover-for='.popover-2-source' arrowAccent='border'>
        <div style={{padding: '10px', width: '180px'}}>Popover for button 2</div>
      </TagPopover>

      <TagButton className='popover-3-source' text='Button3 - Popover Suppress Close' style={{display: 'inline-block'}}/>
      <TagPopover popoverFor='.popover-3-source' arrowAccent='border' suppressCloseIcon='true'>
        <div style={{padding: '10px', width: '180px'}}>Popover for button 3</div>
      </TagPopover>
    </div>
    )
    };`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    return (
    <div style={{display: "flex"}}>
      <Tag3Button className='popover-1-source' text='Button1' style={{display: 'inline-block'}}/>
      <Tag3Popover popover-for='.popover-1-source' arrowAccent='border' tippyProps={{placement: 'bottom'}}>
        <div style={{padding: '10px', width: '180px'}}>Popover for button 1</div>
      </Tag3Popover>

      <Tag3Button className='popover-2-source' text='Button2' style={{display: 'inline-block'}}/>
      <Tag3Popover popover-for='.popover-2-source' arrowAccent='border' tippyProps={{placement: 'bottom'}}>
        <div style={{padding: '10px', width: '180px'}}>Popover for button 2</div>
      </Tag3Popover>

      <Tag3Button className='popover-3-source' text='Button3 - Popover Suppress Close' style={{display: 'inline-block'}}/>
      <Tag3Popover popoverFor='.popover-3-source' arrowAccent='border' suppressCloseIcon={true} tippyProps={{placement: 'bottom'}}>
        <div style={{padding: '10px', width: '180px'}}>Popover for button 3</div>
      </Tag3Popover>
    </div>
    )
    };`,
  },
};

const ControlledOpenPropStory: Story = {
  title: 'Controlled open prop',
  description: 'A popover in React where the open prop is controlled by state',

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [open, setOpen] = React.useState(false);

    return (
      <div>
        <TagButton className='popover-source' text='Click here' style={{display: 'inline-block'}} />
        <TagPopover
          popoverFor='.popover-source'
          open={open}
          onOpened={e => setOpen(true)}
          onClosed={e => setOpen(false)}
        >
          <div style={{padding: '10px'}}>Some content</div>
        </TagPopover>
      </div>
    )
  };`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [open, setOpen] = React.useState(false);

    return (
      <div>
        <Tag3Button className='popover-source' text='Click here' style={{display: 'inline-block'}} />
        <Tag3Popover
          popoverFor='.popover-source'
          open={open}
          onOpened={e => setOpen(true)}
          onClosed={e => setOpen(false)}
        >
          <div style={{padding: '10px'}}>Some content</div>
        </Tag3Popover>
      </div>
    )
  };`,
  },
};

export const TagPopoverDocs: Component = {
  type: 'component',
  name: 'popover',
  description: 'A popover container than opens when another element is clicked',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'popoverFor',
      description: 'The CSS selector for the source element for the popover',
      type: 'string',
    },
    {
      name: 'open',
      default: 'false',
      description: 'Whether the popover is open',
      type: 'boolean',
    },
    {
      name: 'openByClick',
      default: 'true',
      description:
        'Whether the popover will open when you click on the target element. DEPRECATED in v3. Use tippyProps={ trigger: openByClick ? "click" : "" } instead',
      type: 'boolean',
    },
    {
      name: 'arrowAccent',
      description: 'The colour of the arrow',
      type: 'string',
    },
    {
      name: 'suppressCloseIcon',
      description: 'Whether to hide the close icon.',
      type: 'boolean',
    },
    {
      name: 'suppressArrow',
      default: 'false',
      description:
        'Whether to hide the popover arrow. DEPRECATED in v3. Use tippyProps={ arrow: suppressArrow ? false : true } instead',
      type: 'boolean',
    },
    {
      name: 'alwaysOpenWhenClick',
      description:
        'Whether to always open the popover when clicked (rather than toggling opened / closed). DEPRECATED in v3. Use tippyProps={ hideOnClick: alwaysOpenWhenClick ? false : true } instead',
      type: 'boolean',
    },
    {
      name: 'position',
      default: 'bottom',
      description:
        'Where the popover should be positioned by default. If the default positioning takes the popover off the screen then the popover will be positioned as best as it can. DEPRECATED in v3. Use tippyProps={ placement: position } instead',
      type:
        'auto | bottom | bottom-start | bottom-end | top | top-start | top-end | left | left-start | left-end | right | right-start | right-end',
    },
    {
      name: 'autoSize',
      default: 'false',
      description: 'Autosizes the popover to the reference element width. DEPRECATED in v3',
      type: 'boolean',
    },
    {
      name: 'minWidth',
      default: '150',
      description: 'The minimum width of the popover. DEPRECATED in v3',
      type: 'boolean',
    },
    {
      name: 'maxWidth',
      default: '',
      description: 'The maximum width of the popover. DEPRECATED in v3',
      type: 'boolean',
    },
    {
      name: 'dropShadowDisabled',
      default: 'false',
      description: 'Defines whether the drop shadow is disabled on the popover. DEPRECATED in v3',
      type: 'boolean',
    },
    {
      name: 'tippyProps',
      default: '',
      description: 'Only V3: Defines the tippy props.',
      type: 'string',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'opened',
      description: 'Raised when the popover has opened',
      parameters: [],
    },
    {
      name: 'closed',
      description: 'Raised when the popover has closed',
      parameters: [],
    },
  ],
  methods: [],
  stories: [PlaygroundStory, ThreePopoversStory, RichContentStory, ControlledOpenPropStory],
};
